const ITEMS = [
  "Diagnostic Agile",
  "Ingénierie des Exigences",
  "IREB",
  "SAFe®",
  "Scrum",
  "IQBBA",
  "Business Analyse",
  "BPMN",
  "Conformité",
  "Value Stream Mapping",
  "Ingénierie Système",
  "Amélioration Continue",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="border-y border-white/[0.07] bg-[#0d1322] py-5 overflow-hidden" data-testid="marquee-section">
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-heading text-sm sm:text-base font-medium text-slate-500 whitespace-nowrap px-6">
              {item}
            </span>
            <span className="grad-text font-bold">×</span>
          </span>
        ))}
      </div>
    </div>
  );
}
